import React from 'react';
import { Header } from './components/Header';
import { HeroSection } from './sections/HeroSection';
import { ServicesSection } from './sections/ServicesSection';
import { WhyChooseUsSection } from './sections/WhyChooseUsSection';
import { BeforeAfterSection } from './sections/BeforeAfterSection';
import { TestimonialsSection } from './sections/TestimonialsSection';
import { ServiceAreasSection } from './sections/ServiceAreasSection';
import { CommercialCtaSection } from './sections/CommercialCtaSection';
import { ContactSection } from './sections/ContactSection';
import { Footer } from './components/Footer';
export function App() {
  return <div className="min-h-screen bg-white font-sans text-navy selection:bg-red selection:text-white" data-id="element-0">
      <Header data-id="element-1" />
      <main data-id="element-2">
        <HeroSection data-id="element-3" />
        <ServicesSection data-id="element-4" />
        <WhyChooseUsSection data-id="element-5" />
        <BeforeAfterSection data-id="element-6" />
        <TestimonialsSection data-id="element-7" />
        <ServiceAreasSection data-id="element-8" />
        <CommercialCtaSection data-id="element-9" />
        <ContactSection data-id="element-10" />
      </main>
      <Footer data-id="element-11" />
    </div>;
}